import { Banner, Country } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { getCountryName } from '@/helpers/getCountryName';

type CountryMismatchBannerProps = {
  senderCountry: Country;
  siteCountry: Country;
};

const CountryMismatchBanner = ({
  senderCountry,
  siteCountry,
}: CountryMismatchBannerProps) => {
  const { t } = useTranslation('common');

  return (
    <Banner
      id="ship-to-site-country-mismatch-banner"
      isFlat
      isFullWidth
      intent="error"
      title={t('offboardings.deviceShipping.countryMismatchBanner.title')}
      message={t('offboardings.deviceShipping.countryMismatchBanner.message', {
        senderCountry: getCountryName(senderCountry),
        siteCountry: getCountryName(siteCountry),
      })}
    />
  );
};

export default CountryMismatchBanner;
